import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import DxDiagnosisResultForm from '@src/features/company/dx-diagnosis/DxDiagnosisResultForm';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';

function CompanyDxDiagnosisResults() {
  return (
    <CompanyGuard
      canRoles={[COMPANY_ROLE.ADMIN]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <CompanyNoMenusLayout showLogo={true}>
        <CommonHelmet />
        <DxDiagnosisResultForm />
      </CompanyNoMenusLayout>
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisResults;
